import api from "./api"

export const getSupplierPaymentFormData = async () => {
  const response = await api.get("/supplier-payments/form-data")
  return response.data
}

export const getSupplierPayments = async () => {
  const response = await api.get("/supplier-payments")
  return response.data
}

export const createSupplierPayment = async (payload) => {
  const response = await api.post("/supplier-payments", payload)
  return response.data
}

export const cancelSupplierPayment = async (paymentId, payload = {}) => {
  const response = await api.post(
    `/supplier-payments/${paymentId}/cancel`,
    payload
  )
  return response.data
}